import { render, staticRenderFns } from "./ConferenceView.vue?vue&type=template&id=5d4898a5&"
import script from "./ConferenceView.vue?vue&type=script&lang=ts&"
export * from "./ConferenceView.vue?vue&type=script&lang=ts&"
import style0 from "./ConferenceView.vue?vue&type=style&index=0&id=5d4898a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports